<template>
  <div class="home" :style="cssProps">
    <offline @detected-condition="handleConnectivityChange" />

    <div class="loadingScreen" v-if="$store.state.isFirstLoad" />
    <div v-else>
      <div class="upperBand" />
      <div class="midBox">
        <LeftColumn />
        <RightColumn />
        <RightSideColumn />
      </div>
      <div class="versionInfo">Sürüm: {{ version }} b.{{ build }}</div>
      <keep-alive>
        <UploadManager />
      </keep-alive>

      <transition name="fade">
        <div v-if="$store.state.conversation.activeConversation.preview !== undefined">
          <ImageGalleryView v-if="$store.state.conversation.activeConversation.preview.imageGalleryView.isVisible === true" />
        </div>
      </transition>

      <modal name="homepage" :width="450" :height="780" :pivot-x="0.57">
        <ForwardMessage v-if="$store.state.display.modal.viewState === 'forwardMessage'" />
        <AddToGroup v-if="$store.state.display.modal.viewState === 'addToGroup'" />
      </modal>

      <modal name="profileModal" :width="250" :height="250">
        <ProfilePhotoView v-if="$store.state.display.modal.viewState === 'profilePhotoView'" />
      </modal>
    </div>
  </div>
</template>

<script>
import RightSideColumn from '../components/home/rightcolumn/RightSideColumn.vue'
import UploadManager from '../managers/UploadManager.vue'

import RightColumn from '../components/home/rightcolumn/RightColumn.vue'
import LeftColumn from '../components/home/leftcolumn/LeftColumn.vue'

import EventBus from '@/eventbus.js'
import offline from 'v-offline'

import { messageMixin } from '@/mixins/messageMixin.js'

import { socketInputMixin } from '@/mixins/socketInputMixin.js'

import { socketOutputMixin } from '@/mixins/socketOutputMixin.js'

import { Howl } from 'howler'

var vm
var moment = require('moment')

const ImageGalleryView = () => import(/* webpackChunkName: "image-gallery" */ '../components/home/rightcolumn/messages/preview/ImageGalleryView.vue')
const ForwardMessage = () => import(/* webpackChunkName: "forward-message" */ '../components/home/rightcolumn/modal/ForwardMessage.vue')
const AddToGroup = () => import(/* webpackChunkName: "add-to-group" */ '../components/home/rightcolumn/modal/AddToGroup.vue')
const ProfilePhotoView = () => import(/* webpackChunkName: "profile-photo" */ '../components/home/rightcolumn/modal/ProfilePhotoView.vue')

export default {
  mixins: [messageMixin, socketInputMixin, socketOutputMixin],

  components: {
    RightSideColumn,
    ImageGalleryView,
    UploadManager,
    RightColumn,
    LeftColumn,
    ForwardMessage,
    AddToGroup,
    ProfilePhotoView,
    offline
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      build: process.env.VUE_APP_BUILD
    }
  },
  computed: {
    cssProps() {
      return {
        '--topBarColor': this.$config.theme.default.homePage.topBarColor,
        '--loadingMainColor': this.$config.theme.default.homePage.loadingMainColor,
        '--loadingBackgroundColor': this.$config.theme.default.homePage.loadingBackgroundColor,
        '--loadingGif': this.$config.theme.default.homePage.loadingGif
      }
    }
  },

  methods: {
    waitForClickForHowler() {
      document.removeEventListener('click', this.waitForClickForHowler)
      this.newMessageSound = new Howl({
        volume: 0.4,
        src: ['/sound/button_tiny.mp3'],
        preload: true
      })
    },

    reloadUpdatedData() {
      var vm = this
      this.socketRequestUpdatedData()
      setTimeout(function() {
        vm.get_settings()
      }, 2000)
      this.get_stars()
      // this.get_settings()
    },

    handleConnectivityChange(status) {
      this.$store.state.isConnected = status
      if (status && this.$store.state.socket.connection.readyState === 1) {
        this.checkUnsentMessages()
      }
    },

    checkUnsentMessages() {
      if (this.$store.state.message.unsentMessages.length > 0) {
        var index = 0
        this.$store.state.message.unsentMessages.forEach(um => {
          // A small offset time is added because when sent at the same time during for loop, message order can get messed up
          index++
          // We are sending the message now, not when it was written offline
          var messageDate =
            moment()
              .utc()
              .add(index * 5, 'milliseconds')
              .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss

          um.CreateDate = messageDate
          um.UpdateDate = messageDate
          vm.$store.state.socket.connection.send(this.enc(JSON.stringify(um)))

          if (vm.$store.state.socket.connection.readyState === 1) {
            if (!um.isGroup) {
              um.Status = 1
            } else {
              let GroupID = um.To
              let group = vm.$store.state.group.groups.find(g => g.GroupID === GroupID)
              let groupMembers = []
              let groupOwner = group.Owner
              let groupAdmins = group.Admins
              let groupParticipants = group.Participants

              groupMembers.push(groupOwner)
              if (groupAdmins) {
                groupAdmins.forEach(ga => groupMembers.push(ga))
              }
              groupParticipants.forEach(gp => groupMembers.push(gp))

              groupMembers.forEach(gm => {
                let groupMessageStatus = {}
                groupMessageStatus.UserID = gm
                groupMessageStatus.GroupID = GroupID
                groupMessageStatus.MessageID = um.MessageID
                groupMessageStatus.DeliverDate = messageDate
                groupMessageStatus.UpdateDate = messageDate
                groupMessageStatus.SeenDate = null
                groupMessageStatus.Status = 1
                groupMessageStatus.UniqueID = GroupID

                vm.$store.state.messagestatus.messageStatuses.push(groupMessageStatus)
              })
            }
          }
        })
        this.$store.state.message.unsentMessages = []
      }
    },

    pageExitCheck($event) {
      // event comes undefined in first load, we filter that and check if there are unsent messages or anything written in inputbar currently
      if (this.$store.state.isFirstLoad || (this.$store.state.message.unsentMessages.length === 0 && this.$store.state.message.currentMessageText.trim().length === 0)) {
        return true
      }

      $event.returnValue = 'Kaydedilmemiş değişiklikleriniz var, çıkmak istediğinize emin misiniz?'
      // return confirmationMessage
    }
  },

  created() {
    vm = this
    // eslint-disable-next-line
    ifvisible.on('focus', function() {
      vm.setReadStatusOfActiveConversationMessages()
    })
    EventBus.$on('reloadUpdatedData', this.reloadUpdatedData)
    EventBus.$on('SocketOpened', this.checkUnsentMessages)
  },

  beforeMount() {
    window.addEventListener('beforeunload', this.pageExitCheck)
  },

  mounted() {
    this.$store.state.socket.shouldReconnect = true
    this.buildWebSocket()
    document.addEventListener('click', this.waitForClickForHowler)
  },

  beforeDestroy() {
    EventBus.$off('reloadUpdatedData', this.reloadUpdatedData)
    EventBus.$off('SocketOpened', this.checkUnsentMessages)
    window.removeEventListener('beforeunload', this.pageExitCheck)
    document.removeEventListener('click', this.waitForClickForHowler)

    this.$store.state.socket.shouldReconnect = false
    if (this.$store.state.socket.reconnectTimeout !== null) {
      clearTimeout(this.$store.state.socket.reconnectTimeout)
      this.$store.state.socket.reconnectTimeout = null
    }

    const connection = this.$store.state.socket.connection
    if (connection !== null) {
      connection.onopen = null
      connection.onclose = null
      connection.onerror = null
      connection.onmessage = null
      if (connection.readyState === WebSocket.CONNECTING || connection.readyState === WebSocket.OPEN) {
        connection.close()
      }
      this.$store.state.socket.connection = null
    }
  }
}
</script>

<style scoped>
.loadingScreen {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  background-color: var(--loadingBackgroundColor);
  background-image: var(--loadingGif);
  background-repeat: no-repeat;
  background-position: center;
}

.v--modal-overlay {
  background: rgba(255, 255, 255, 0.7);
}

.home {
  position: relative;
  height: 100%;
  margin: 0;
}

.upperBand {
  background-color: var(--topBarColor);
  height: 100px;
}

.midBox {
  background-color: white;
  width: 95%;
  max-width: 1390px;
  min-width: 300px;
  height: calc(100vh - 40px);
  margin: auto;
  margin-top: -80px;
  box-shadow: 0 4px 80px 0 rgba(0, 0, 0, 0.1), 0 0px 0px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  align-content: stretch;
  overflow: auto;
}

@media only screen and (max-width: 1460px) {
  .upperBand {
    height: 0px;
  }

  .midBox {
    margin: 0px;
    width: 100%;
    height: 100vh;
    max-width: 1460px;
  }
}

.versionInfo {
  position: fixed;
  bottom: 5px;
  left: 5px;
  color: rgb(139, 139, 139);
  font-size: 9px;
}
</style>
